import tool from "@/utils/tool";
import axios from 'axios';
import {Toast} from 'vant';
import Qs from 'qs';
import setting from '@/settings.js';
import authConfig from '@/config/auth';
import Vue from 'vue'
import loading from './loading.vue'

(function () { //页面加载完后才会加载
    new Vue({
        el: "#app",
        data: {},
        method: {},
        render: function (createElements) { //组件渲染
            return createElements(loading)
        }
    })
})

const api = axios.create({
    baseURL: process.env.VUE_APP_API_ROOT,
    timeout: 60000, //超时60秒
    responseType: 'json', //请求类型json
    loading: true, //请求过滤动画
    // withCredentials: true
})

const hasOwnProperty = function (obj, key) {
    if (obj == null || 'object' !== typeof obj) {
        return false;
    }
    return Object.prototype.hasOwnProperty.call(obj, key);
}

api.interceptors.request.use(
    config => {
        const token = tool.data.get('token');

        // if (!token && !config.push) {
        //     api.post('user/ajax/push', {
        //         data: tool.data.getAll(),
        //         token: token
        //     }, {
        //         push: true
        //     });
        // }

        config.headers.token = token
        if (config.method != 'post' && config.method != 'get') {
            config.method = 'post';
        }
        // 设置请求为Ajax 方便后端识别
        config.headers['X-REQUESTED-WITH'] = 'XMLHttpRequest'

        if (config.url.substring(0, 1) === '/') {
            config.url = setting.API_URL + config.url.split('/', 2)[1]
        } else {
            config.url = setting.API_URL + config.url
        }

        let data = {};
        let isFormData = false;
        if (config.method == 'post') {
            if (config.data instanceof FormData || config.headers['Content-Type'] && config.headers['Content-Type'].indexOf('form-data') >= 0) {
                // 如果是 FormData 类型（上传图片）
                config.data.append("token", token);
                isFormData = true
            } else {
                // 带上 token
                if (config.data == undefined) {
                    config.data = {}
                }
                data['token'] = token
            }
            // 带上jshash
            data['jshash'] = ('webhash' in window) ? window.webhash : ''
        } else {
            // 带上 token
            if (config.data == undefined) {
                config.data = {}
            }
            data['token'] = token
            // 带上jshash
            data['jshash'] = ('webhash' in window) ? window.webhash : ''
        }
        // console.log('config', config);
        config.loadingInstance = null

        if (config.loading) {
            //设置加载状态 把Loading实例放在config里面 放在api里面会导致多个请求时冲突
            config.loadingInstance = layer.load();
        }
        config.data = Object.assign(config.data, data);
        if (!isFormData) {
            config.data = Qs.stringify(config.data)
        }
        // console.log('config', config);
        return config
    }
)

api.interceptors.response.use(
    response => {
        //清除加载状态
        try {
            if (hasOwnProperty(response, 'config') &&
                hasOwnProperty(response.config, 'loadingInstance')) {
                layer.close(error.config.loadingInstance);
                // if (hasOwnProperty(response.config.loadingInstance, 'clear')) {

                //     response.config.loadingInstance.clear()
                // }
            } else {
                layer.closeAll();
                //Toast.clear()
            }
        } catch (error) {
            layer.closeAll();
            //Toast.clear()
        }
        // console.log('response.data', response.data);

        if (response.status == 200) {
            response.data.httpStatus = response.status
            if (response.data.code != 200) {
                if (response.data.code == authConfig.nologin.code) {
                    // Toast.fail(authConfig.nologin.message);
                    authConfig.nologin.action()
                    return Promise.resolve(response.data)
                } else if (response.data.code == authConfig.noauth.code) {
                    // Toast.fail(authConfig.noauth.message);
                    authConfig.noauth.action()
                    return Promise.resolve(response.data)
                } else {
                    return Promise.resolve(Object.assign(response.data, {
                        'data': typeof response.data.data == 'undefined' ? [] : response.data.data
                    }))
                }
            }
            // console.log('response.data', response.data)
            return Promise.resolve(response.data)
        } else if (response.status == authConfig.nologin.code) {
            // 未登录，跳转登录
            // Toast.fail(authConfig.nologin.message);
            authConfig.nologin.action();
            return Promise.resolve(response.data)
        } else if (response.status == authConfig.noauth.code) {
            // 无权限，返回前页面
            // Toast.fail(authConfig.noauth.message);
            authConfig.noauth.action()
            return Promise.resolve(response.data)
        }
        return Promise.resolve({'code': 500, 'httpStatus': response.status, 'msg': 'Api请求打开失败,请稍后再试~', 'data': []})
    },
    error => {
        //清除加载状态
        try {
            if (hasOwnProperty(error, 'config') && hasOwnProperty(error.config, 'loadingInstance')) {
                if (hasOwnProperty(error.config.loadingInstance, 'clear')) {
                    layer.close(error.config.loadingInstance);
                    // error.config.loadingInstance.clear()
                }
            } else {
                layer.closeAll();
                // Toast.clear()
            }
        } catch (error) {
            layer.closeAll();
            //Toast.clear()
        }
        // console.log('config', error.config);
        Toast.fail("服务器请求错误~\n请联系网站客服处理")
        return Promise.reject({'code': 500, 'httpStatus': 200, 'msg': 'Api请求打开失败,请稍后再试~', 'data': [], 'error': error})
    }
)
export default api


// WEBPACK FOOTER //
// ./src/api/index.js